import React, { Fragment } from 'react';

const InputField = ({ label, input, meta, text }) => (
    <Fragment>
        <label className="form-control-label">{label}</label>
        <div className="custom-control custom-checkbox mb-3">
            <input className="custom-control-input" type="checkbox" {...input} />
            <label className="custom-control-label">{text}</label>
        </div> 
    </Fragment>
);

export default InputField;


// WEBPACK FOOTER //
// ./src/components/CheckboxField.js